"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useHasGlobalTreeWritePermission = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const graphql_1 = require("../../../../__generated__/graphql");
const get_global_product_tree_query_1 = require("../get-global-product-tree.query");
const useHasGlobalTreeWritePermission = (options) => {
    var _a, _b, _c;
    const { data, loading } = (0, react_2.useQuery)(get_global_product_tree_query_1.GET_GLOBAL_PRODUCT_TREE, { skip: options === null || options === void 0 ? void 0 : options.skip });
    const globalTree = (_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.productTrees) === null || _a === void 0 ? void 0 : _a.edges) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.node;
    const hasWritePermission = (0, react_1.useMemo)(() => {
        var _a;
        const permissions = globalTree === null || globalTree === void 0 ? void 0 : globalTree.myPermissions;
        return (_a = permissions === null || permissions === void 0 ? void 0 : permissions.some((permission) => [graphql_1.PermissionAction.Grant, graphql_1.PermissionAction.Write].includes(permission))) !== null && _a !== void 0 ? _a : false;
    }, [globalTree]);
    return {
        hasGlobalTreeWritePermission: hasWritePermission,
        globalTreeId: globalTree === null || globalTree === void 0 ? void 0 : globalTree.id,
        loading,
    };
};
exports.useHasGlobalTreeWritePermission = useHasGlobalTreeWritePermission;
